import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class UserDropdown extends Component {

  state={
    dropdownVisible: false,
    hover: -1
  }

  toggleDrop = () => {
    this.setState( ({dropdownVisible}) => ({dropdownVisible: !dropdownVisible}));
  }

  render() {
    return (
      <div className="dropdown">
        <div className="dropdown__name" onClick={this.toggleDrop}>Gruvi User <FontAwesomeIcon icon="angle-down" /></div>
        <div className={this.state.dropdownVisible ? "dropdown__box": "dropdown__box dropdown__box--collapsed"} onMouseLeave={ () => this.setState({hover: -1})}>
          <Link className={this.state.hover === 0 ? "dropdown__back hovered" : "dropdown__back"} onMouseEnter={ () => this.setState({hover: 0})} to="/">Home</Link>
          <Link className={this.state.hover === 1 ? "dropdown__admin hovered" : "dropdown__admin"} onMouseEnter={ () => this.setState({hover: 1})} to="/admin">Admin</Link>
          <div className={this.state.hover === 3 ? "dropdown__logout hovered" : "dropdown__logout"} onMouseEnter={() => this.setState({hover: 3})} onClick={() => this.props.logout()} >Logout</div>
        </div>
      </div>
    )
  }
}

export default UserDropdown;



// WEBPACK FOOTER //
// ./src/components/UserDropdown.js